import classNames from 'classnames';
import {i18n} from 'mc/lib';
import PropTypes from 'prop-types';
import React from 'react';
import {Col, Row} from 'reactstrap';
import {Stage, StageItem} from '../common';
import './ZadostLayout.scss';

const ZadostLayout = ({className, stage, children}) => (
    <div className={classNames('zadost-layout', className)}>
        <Row>
            <Col xs={12}>
                <Stage stage={stage}>
                    <StageItem>{i18n('zadostLayout.stage.1')}</StageItem>
                    <StageItem>{i18n('zadostLayout.stage.2')}</StageItem>
                    <StageItem>{i18n('zadostLayout.stage.3')}</StageItem>
                    <StageItem>{i18n('zadostLayout.stage.4')}</StageItem>
                </Stage>
            </Col>
        </Row>
        {children}
    </div>
);

ZadostLayout.propTypes = {
    className: PropTypes.string,
    stage: PropTypes.number.isRequired,
    children: PropTypes.node,
};

export default ZadostLayout;
